export default {
    url: 'ocean-ev-charger',
    include: ['us'],
};

